<template>
  <!-- 
    * Copyright: T-Systems México S.A. de C.V.
    * Descripción: Vista atributos, permite consultar, crear, editar y eliminar atributos disponibles para las bicis
    * Autor: Omar Ramos
    * F.Creación: 
  -->
  <layout :title="$t('moduleTitle')">
    <!-- Contenido -->
    <template v-slot:content>
      <!-- modal con formulario para la creacion de una nueva sala de juntas -->
      <v-dialog persistent v-model="newDialog" width="500">
        <v-card>
          <v-card-title class="headline grey lighten-2" primary-title>{{$t("tblbutton")}}</v-card-title>

          <v-card-text>
            <v-container>
              <v-form ref="newMapForm" lazy-validation>
                <v-row>
                  <v-col cols="12">
                    <v-text-field v-model="currentCar.name" :label="$t('lblName')"></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field
                      v-model="currentCar.comments"
                      :label="$t('lblDescription')"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <p class="caption error--text" v-html="fileUploadErrorMessage"></p>
                  </v-col>
                </v-row>
              </v-form>
            </v-container>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click.stop="closeNewDialog()">{{$t("mdlCancel")}}</v-btn>
            <v-btn text @click.stop="doNewDialog()" color="primary">{{$t("mdlSave")}}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- modal con formulario para la edicion de una sala de juntas -->
      <v-dialog persistent v-model="uploadDialog" width="500">
        <v-card>
          <v-card-title class="headline grey lighten-2" primary-title>{{$t("dlgUploadTitle")}}</v-card-title>

          <v-card-text>
            <v-container>
              <v-form ref="newMapForm" lazy-validation>
                <v-row>
                  <v-col cols="12">
                    <v-text-field v-model="currentCar.name" :label="$t('lblName')"></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field
                      v-model="currentCar.comments"
                      :label="$t('lblDescription')"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <p class="caption error--text" v-html="fileUploadErrorMessage"></p>
                  </v-col>
                </v-row>
              </v-form>
            </v-container>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click.stop="closeUploadDialog()">{{$t("mdlCancel")}}</v-btn>
            <v-btn text @click.stop="doUploadDialog()" color="primary">{{$t("mdlSave")}}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- caja de texto para buscar informacion en tabla de contenido -->
      <v-text-field
        solo
        class="mt-4"
        :label="$t('lblSearch')"
        prepend-inner-icon="mdi-account"
        v-model="search"
      ></v-text-field>
      <!-- boton navegacion -->
      <router-link
        class="white--text"
        v-if="$routerHistory.hasPrevious()"
        :to="{ path: $routerHistory.previous().path }"
      >
        <v-btn class="mb-2" tile color="primary">
          <v-icon left>mdi-chevron-left</v-icon>
          {{$t('lblback')}}
        </v-btn>
      </router-link>
      <!-- Tabla de contenido -->
      <v-data-table
        :headers="headers"
        :items="cars"
        :loading="isLoading"
        :search="search"
        loading-text="Cargando elementos en tabla"
        color="primary"
      >
        <template v-slot:top>
          <v-toolbar flat color="primary">
            <v-toolbar-title
              class="white--text"
            >{{$t('tblTitle', { locationName: getLocationName()})}}</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-spacer></v-spacer>
            <v-btn
              class="ma-2"
              outlined
              color="white"
              @click.stop="newDialog = true"
            >{{$t('tblbutton')}}</v-btn>
          </v-toolbar>
        </template>
        <!-- Panel de estado -->
        <template v-slot:item.estado="{ item }">
          <v-col v-if="item.status === 1">
            <v-btn icon color="primary" @click="deleteItem(item)">
              <v-icon>mdi-thumb-up</v-icon>
            </v-btn>
          </v-col>
          <v-col v-else>
            <v-btn icon color="grey" @click="deleteItem(item)">
              <v-icon>mdi-thumb-down</v-icon>
            </v-btn>
          </v-col>
        </template>
        <!-- Panel de acciones -->
        <template v-slot:item.action="{ item }">
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn icon class="mr-2" color="grey" v-on="on" @click="showUploadDialog(item)">
                <v-icon>mdi-pencil</v-icon>
              </v-btn>
            </template>
            <span>{{$t('lblEdit')}}</span>
          </v-tooltip>
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn icon class="mr-2" color="grey" v-on="on" @click="navigatepictureRooms(item)">
                <v-icon>mdi-folder-multiple-image</v-icon>
              </v-btn>
            </template>
            <span>{{$t('lblImage')}}</span>
          </v-tooltip>
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn icon class="mr-2" color="grey" v-on="on" @click="navigateAttributes(item)">
                <v-icon>mdi-chart-gantt</v-icon>
              </v-btn>
            </template>
            <span>{{$t('lblAttribe')}}</span>
          </v-tooltip>
        </template>
      </v-data-table>
      <v-snackbar v-model="snackbar">
        {{ mensaje }}
        <v-btn color="primary" text @click="snackbar = false">Cerrar</v-btn>
      </v-snackbar>
    </template>
  </layout>
</template>

<script>
import Layout from "@/components/Layouts/company";
import i18nMessages from "./i18n.messages";
import { mapGetters } from "vuex";
import _ from "lodash";

export default {
  components: {
    layout: Layout
  },
  created() {
    this.$i18n.locale = this.locale;
    this.loadData();
    this.updateHeadersLocale();
  },
  beforeDestroy() {},
  i18n: i18nMessages,
  data: function() {
    return {
      newDialog: false,
      deleteDialog: false,
      uploadDialog: false,
      viewDialog: false,
      snackbar: false,
      mensaje: "",
      search: "",
      loading: true,
      dialog: false,
      cars: [],
      currentCar: { resource: {} },
      fileUploadErrorMessage: "",
      ubicRules: [
        v => v.length > 0 || "Debes ingresar una ubicacion",
        v => v.length < 100 || "No puedes ingresar mas de 100 caracteres"
      ],
      headers: [
        { id: "headerName", text: "Nombre", value: "name" },
        { id: "headerComments", text: "Descripcion", value: "comments" },
        {
          id: "headerEstado",
          text: "Estado",
          value: "estado",
          sortable: false
        },
        {
          id: "headerAction",
          text: "Acciones",
          value: "action",
          sortable: false
        }
      ],
      editedItem: {
        id: null,
        name: "",
        comments: "",
        status: 1
      }
    };
  },
  mounted: () => {},
  computed: {
    ...mapGetters(["isLoading"]),
    locale() {
      return this.$store.getters["locale"];
    },
    formTitle() {
      return this.editedItem.id === null
        ? "Nueva Ubicación"
        : "Editar Ubicación";
    }
  },
  watch: {
    locale(value) {
      this.$i18n.locale = value;
      this.updateHeadersLocale();
    }
  },
  methods: {
    getLocationName() {
      if (this.cars && this.cars.length > 0) {
        return this.cars[0].location;
      }
      return "";
    },
    setCurrentMeeting(item) {
      //Realizamos una copia del objeto map
      //utilizan el método clone de la utileria LODASH
      this.currentCar = _.clone(item);
    },
    // Actualiza el idioma de los encabezados de la tabla
    updateHeadersLocale() {
      this.headers = this.headers.map(header => {
        header.text = this.$t(header.id);
        return header;
      });
    },
    loadData() {
      //** console.log("invocaion loadData");
      let settings = {
        locationId: this.$route.params.idLocation,
        itemTypeId: 3
      };
      this.$GET("/api/locations/{{locationId}}/items/{{itemTypeId}}", settings)
        .then(cars => {
          this.cars = cars.map(item => {
            return {
              id: item.id,
              comments: item.comments,
              lastUpdate: item.lastUpdate,
              updatedBy: item.updatedBy,
              status: item.status,
              itemTypeId: item.itemTypeId,
              locationId: item.locationId,
              name: item.name,
              itemType: item.itemType,
              location: item.location
            };
          });
        })
        .catch(() => {
          //** console.log(e)
        });
    },
    closeNewDialog() {
      this.newDialog = false;
      this.currentCar = { resource: {} };
      this.$refs.newMapForm.reset();
    },
    doNewDialog() {
      let payload = {
        data: {
          itemTypeId: 3,
          locationId: this.$route.params.idLocation,
          name: this.currentCar.name,
          comments:
            this.currentCar.comments == null
              ? " "
              : this.currentCar.comments
        }
      };
      //** console.log("/api/items", payload);
      this.$POST("/api/items", payload)
        .then(() => {
          //** console.log(response);
          this.loadData();
          this.newDialog = false;
          this.$refs.newMapForm.reset();
        })
        .catch(() => {
          // En caso de error presentar un mensaje
          // al usuario
          //** console.log(e);
          //this.fileUploadErrorMessage = "Ocurrió un error al crear el mapa";
        })
        .finally(() => {});
    },
    showUploadDialog(item) {
      //this.currentMeetingRooms = item;
      this.setCurrentMeeting(item);
      this.uploadDialog = true;
    },
    closeUploadDialog() {
      this.uploadDialog = false;
      this.currentCar = { resource: {} };
      this.$refs.updateMapForm.reset();
    },
    doUploadDialog() {
      let payload = {
        params: {
          itemId: this.currentCar.id
        },
        data: {
          name: this.currentCar.name,
          comments: this.currentCar.comments,
          status: this.currentCar.status,
          lastUpdate: this.currentCar.lastUpdate
        }
      };
      //** console.log("/api/items/{{itemId}}", payload);
      this.$PUT("/api/items/{{itemId}}", payload)
        .then(() => {
          //** console.log(response);
          this.loadData();
          this.uploadDialog = false;
          this.currentCar = { resource: {} };
        })
        .catch(() => {
          // En caso de error presentar un mensaje
          // al usuario
          //** console.log(e);
          //this.fileUploadErrorMessage = "Ocurrió un error al crear el mapa";
        })
        .finally(() => {});
    },
    atras() {
      this.$router.push({ path: "/locations" });
      ////** console.log(this.meetingRooms[0].locationId)
    },
    navigatepictureRooms(item) {
      //** console.log("pictureRooms/" + item.id);
      this.$router.push({ path: "/pictureRooms/" + item.id + "/"+item.name+"/" });
      //this.$router.push({ path: "rooms/" + item.id });
    },
    navigateAttributes(item) {
      //** console.log("idRoom/" + item.id);
      this.$router.push({ path: "/attributesByItem/" + item.id + "/" +this.$route.params.idLocation+ "/3/" });
    },
    deleteItem(item) {
      //** console.log(item.id);
      let body = {
        params: {
          itemId: item.id
        },
        data: {
          name: item.name,
          lastUpdate: item.lastUpdate,
          comments: item.comments,
          status: item.status === 0 ? 1 : 0
        }
      };
      //** console.log("/api/locations/", body);
      this.$PUT("/api/items/{{itemId}}", body)
        .then(() => {
          // //** console.log(this.locations),
          // Object.assign(this.locations[this.editedIndex], this.item)
          this.loadData();
        })
        .catch(() => {
          //** console.log(e)
        });
    }
  }
};
</script>